/**
 * React component that is responsible for rendering a button that opens
 *  a modal dialog based on the provided content
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames'
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from 'components/theme/Button'
import styles from './ModalButton.module.scss'

const ModalButton = ({
  className,
  variant,
  text,
  isDarkBackground,
  children,
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <Button
        className={cx(className)}
        variant={variant}
        onClick={handleClickOpen}>
        {text}
      </Button>
      <Dialog
        classes={{
          paper: cx(styles.paperBg),
        }}
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth>
        <IconButton className={cx(styles.closeButton)} aria-label="close" onClick={handleClose}>
          <CloseIcon className={cx(styles.closeIcon)} />
        </IconButton>
        <div className={cx({ [styles.dark]: isDarkBackground })}>
          {children}
        </div>
      </Dialog>
    </>
  )
}

ModalButton.propTypes = {
  className: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  variant: PropTypes.string,
  isDarkBackground: PropTypes.bool,
  children: PropTypes.node,
}

export default ModalButton
